var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"score-bar-wrapper"},_vm._l((5),function(index){return _c('div',{key:index,staticClass:"lender-score-bar",class:[index <= _vm.score ? 'filled' : 'outlined']})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }